<template>
  <div>
    <el-tabs v-model="activeTabName">
      <el-tab-pane name="账号留存" label="账号留存">
        <AccountRetentionPage v-if="activeTabName == '账号留存'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import AccountRetentionPage from "./tab-pages/AccountRetentionPage";
export default {
  data() {
    return {
      activeTabName: "账号留存",
    };
  },

  components: {
    AccountRetentionPage,
  },
};
</script>